import Image from "next/image";
import CustomButton from "../../shared/CustomButton";
import ImageWithLoader from "../../shared/imageWithLoader/ImageWithLoader";
import { useContext } from "react";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";
import { usePopupContext } from "@/app/store/context/popupContext";
import { useNavigation } from "@/app/hooks/useNavigation"

const NewsCard = ({ index, activeAccordion, data, insideAmenitiesDetailsPage, optimizedImage }: any) => {

    const { isIpad } = useContext(screenSizeContext)
    const router = useNavigation()

    const formatDate = (dateString?: string) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
            // day: "2-digit",
            month: "long",
            year: "numeric",
        });
    };

    const {
        setisOtherPopupOpen,
        setPopupInnerData
    } = usePopupContext()
    

    return (
        <div key={index} className={`${data.bg} 
        flex 
        flex-col
        px bg h-[100%] py-6
         lg:grid lg:grid-cols-3 lg:gap-6 lg:py-10`}>
            <div className="col-span-1">
                <p className="font-national text-bodyS text-oWhite-100 py-1 px-2 bg-oWhite-10 w-fit mb-[.6rem]">{data?.slug_label}</p>
                <p className={`font-national text-bodyM text-oWhite-100  lining-nums proportional-nums  mb-6`}>{formatDate(data.date)}</p>
                {/* <p className={`font-national text-bodyM text-oWhite-100  lining-nums proportional-nums ${index == activeAccordion ? "mb-10" : "mb-6"}`}>{moment(data?.date).format('D MMMM YYYY')}</p> */}
            </div>
            <div className="col-span-1 transform lg:translate-x-[-5rem]">
                <h3 className="text-bodyL text-oWhite-100 mb-12  lg:text-h6  lg:mb-[4.5rem]">{data?.card_title?.en}</h3>
                <p className="font-national text-bodyM text-oWhite-60 mb-5">{data?.card_description?.en}</p>
                <CustomButton
                    text="Learn More"
                    hasIcon
                    style="transparent"
                    action={() => {
                        if (insideAmenitiesDetailsPage) {
                            setisOtherPopupOpen(true);
                            setPopupInnerData(data);
                        } else {
                            router.push(`/media-center?slug=${data?.url_slug}`);
                        }
                    }}
                />
            </div>
            <div className="flex justify-end">
                <div className="relative col-span-1 w-[100%] h-[25rem] md:h-[30rem] lg:h-[25rem] mt-10 lg:mt-0 lg:w-[21rem]">
                    {data?.card_image_desktop?.media_name && (
                        optimizedImage ? (
                            <ImageWithLoader
                                src={
                                    isIpad
                                        ? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL + data?.card_image_mobile?.media_name
                                        : process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL + data?.card_image_desktop?.media_name
                                }
                                alt={data?.card_title?.en || "event"}
                                sizeVariant="sidebar"
                                quality={80}
                            />
                        ) : (
                            <Image
                                src={
                                    isIpad
                                        ? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL + data?.card_image_mobile?.media_name
                                        : process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL + data?.card_image_desktop?.media_name
                                }
                                alt="event"
                                fill
                                objectFit="cover"
                            />
                        )
                    )}
                </div>
            </div>

            {
                isIpad && index == 2 &&
                <div className="flex justify-center mt-12">
                    <CustomButton
                        text="All Events"
                        hasIcon
                        style="transparent"
                        action={() => router.push("/media-center")}
                    />
                </div>

            }
        </div>
    );
}

export default NewsCard;